import { InjectionToken, Provider, Type } from '@angular/core';
import { Endpoint } from 'utils/enums/endpoint.util';
import { GenericService } from './generic.service';

const serviceFactoryCreator =
  <T>(serviceClass: Type<GenericService<T>>, endpoint: Endpoint) =>
  (): GenericService<T> => {
    const service = new serviceClass();
    service.endpoint = endpoint;
    return service;
  };

export const createProvider = <T>(
  token: InjectionToken<GenericService<T>>,
  serviceClass: Type<GenericService<T>>,
  endpoint: Endpoint
): Provider => ({
  provide: token,
  useFactory: serviceFactoryCreator(serviceClass, endpoint),
});
